import TICKET_ANIMATIONS from '../helpers/TicketAnimations';
import TICKET_CALL_TYPE from '../helpers/TicketCallType';
import TICKET_QUEUE_TYPE from '../helpers/TicketQueueType';
import {generateAudioCallByTicket} from '@/helpers/utils';

export default {
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      tempTicket: null,
      showTempTicket: false
    };
  },
  computed: {
    infoscreenData() {
      return this.$store.infoscreenData;
    }
  },
  methods: {
    getCurrentTickets(count) {
      if (this.items.length < count) {
        return [...this.items, ...new Array(count - this.items.length).fill(null)];
      } else {
        return this.items.slice(-count);
      }
    },
    getTicketComponentByTicketId(ticketId) {
      return this.$children.find((childComponent) => {
        return this.componentIsTicket(childComponent) && childComponent.ticket.id === ticketId;
      });
    },
    getTicketComponent(vueInstance, ticketId) {
      if (this.componentIsTicket(vueInstance) && vueInstance.ticket.id === ticketId)
        return vueInstance;

      if (vueInstance.$children.length) {
        let result;
        for (const childInstance of vueInstance.$children) {
          result = this.getTicketComponent(childInstance, ticketId);
          if (result) break;
        }

        return result;
      }
    },
    componentIsTicket(component) {
      const targetComponentName = component.$options.name;
      const componentNames = ['TicketCommon', 'TicketCommonNew', 'TicketGreed', 'TicketGreedNew', 'TicketInline'];

      return componentNames.some((componentName) => componentName === targetComponentName);
    },
    callTicketFullscreen({ticket, ticketCallMode}) {
      return () => {
        return new Promise((resolve) => {
          const isAnimationEnabled =
            this.infoscreenData.ticketCallAnimation === TICKET_ANIMATIONS.FULLSCREEN;
          this.tempTicket = ticket;

          this.$nextTick(() => {
            const targetTicketComponent = this.$refs.tempTicket;
            if (!targetTicketComponent) return;

            this.showTempTicket = isAnimationEnabled;
            const callProps = {ticket, ticketCallMode};
            const callOptions = {animation: isAnimationEnabled, audio: true};

            return targetTicketComponent.callTicket
              .call(targetTicketComponent, callProps, callOptions)
              .finally(() => {
                this.showTempTicket = false;
                this.tempTicket = null;
                resolve();
              });
          });
        });
      };
    },
    callTicketCommon({ticket, ticketCallMode}) {
      // const targetTicketComponent = this.getTicketComponentByTicketId(ticket.id);
      const targetTicketComponent = this.getTicketComponent(this, ticket.id);
      return targetTicketComponent.callTicket.bind(targetTicketComponent, {ticket, ticketCallMode});
    },
    callTicketSoundOnly({ticket}) {
      return () => {
        if (!this.$store.deviceStartData.is_sound_enabled) return Promise.resolve();

        return Promise.all([
          generateAudioCallByTicket(
            this.$store.infoscreenData.audioNotifier,
            ticket,
            TICKET_CALL_TYPE.GONG
          )
        ]);
      };
    }
  },
  mounted() {
    this.$parent.$on(
      'callTicket',
      ({ticket, ticketCallMode, queueType = TICKET_QUEUE_TYPE.WINDOW}) => {
        this.infoscreenData.externalSoundIsCalling = true;

        let callTicketAction;

        if (queueType === TICKET_QUEUE_TYPE.OFFICE) {
          callTicketAction = this.callTicketSoundOnly({ticket, ticketCallMode});
        } else {
          const CALL_TICKET_ACTIONS = {
            [TICKET_ANIMATIONS.COMMON]: this.callTicketCommon.bind(this),
            [TICKET_ANIMATIONS.FULLSCREEN]: this.callTicketFullscreen.bind(this)
          };

          callTicketAction = CALL_TICKET_ACTIONS[this.infoscreenData.ticketCallAnimation]({
            ticket,
            ticketCallMode,
            queueType
          });
        }

        if (!callTicketAction) return;

        this.infoscreenData.actionsQueue.add(callTicketAction);
        this.infoscreenData.actionsQueue.execute(false, () => {
          this.infoscreenData.externalSoundIsCalling = false;
        });
      }
    );
  }
};
